import { ComplianceFramework } from '@trustero/trustero-api-web/lib/audit/framework_pb'
import { CONTROL_TEST_NAMES } from 'src/pages/AuditBot/accordion/subsection/ControlChecks/AuditBotControlChecks.constants'
import { AUDIT_RESULT } from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { IsGatekeeperEnabled, GatekeeperFlag } from 'src/context/Gatekeeper'
import {
  CONTROL_CHECK_RESULT_PILL_COLOR,
  ControlListItemConfig,
  ControlListItemConfigMap,
  ControlListItemConfigurations,
} from './ControlListItem.constants'

export const getComplianceFrameworksForControl = (
  complianceFrameworks: ComplianceFramework[],
  currentIdList: string[],
): ComplianceFramework[] =>
  complianceFrameworks.filter((framework: ComplianceFramework) =>
    currentIdList?.includes(framework.getId()),
  ) || []

export const getMismatch = (
  complianceFrameworkIdsList: string[],
  complianceFrameworksInUse: ComplianceFramework[],
  hasAudit: boolean,
): boolean => {
  if (!hasAudit || !complianceFrameworkIdsList.length) {
    return false
  }
  return !complianceFrameworksInUse.some((framework) =>
    complianceFrameworkIdsList.includes(framework.getModelId()),
  )
}

export const getControlsListItemConfig = (
  config?: ControlListItemConfig,
): ControlListItemConfigMap =>
  config
    ? ControlListItemConfigurations[config]
    : ControlListItemConfigurations[ControlListItemConfig.DEFAULT]

export const getControlsListItemTemplateColumns = (
  showContentMatch: boolean,
  canViewAuditScans: boolean,
  config?: ControlListItemConfig,
): string => {
  const showLabels = IsGatekeeperEnabled(GatekeeperFlag.LABELS)

  let template = ''
  switch (config) {
    case ControlListItemConfig.DEFAULT:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(8, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template

    case ControlListItemConfig.AI_DASHBOARD:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) 1fr auto repeat(2, fit-content(200px))'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) 1fr repeat(2, fit-content(200px))'
      } else if (!canViewAuditScans && showLabels) {
        template = 'min-content fit-content(20ch) 1fr auto'
      } else {
        template = 'min-content fit-content(20ch) 1fr'
      }
      return showContentMatch ? `min-content ${template}` : template
    case ControlListItemConfig.EVIDENCE:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(8, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template

    case ControlListItemConfig.FRAMEWORK_REQUIREMENT:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      } else {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(5, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template
    case ControlListItemConfig.CONTROLS_BY_REQUIREMENT:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(8, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template
    case ControlListItemConfig.EVIDENCE_VIA_REQUEST:
      if (canViewAuditScans && showLabels) {
        template = 'min-content min-content minmax(auto, 30%) repeat(8, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template = 'min-content min-content minmax(auto, 30%) repeat(7, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template = 'min-content min-content minmax(auto, 30%) repeat(7, auto)'
      } else {
        template = 'min-content min-content minmax(auto, 30%) repeat(6, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template
    default:
      if (canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(8, auto)'
      } else if (canViewAuditScans && !showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else if (!canViewAuditScans && showLabels) {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(7, auto)'
      } else {
        template =
          'min-content fit-content(20ch) minmax(auto, 30%) repeat(6, auto)'
      }
      return showContentMatch ? `min-content ${template}` : template
  }
}

export const getControlCheckResultPillLabel = (
  result: AUDIT_RESULT,
  testName?: CONTROL_TEST_NAMES,
): string => {
  switch (result) {
    case AUDIT_RESULT.PASS:
      return 'Passed'
    case AUDIT_RESULT.FAIL:
      return 'Failed'
    case AUDIT_RESULT.NOT_APPLICABLE:
      return 'Not Applicable'
    case AUDIT_RESULT.LAMBDA_ERROR:
    case AUDIT_RESULT.UNKNOWN:
      return 'Could not be evaluated'
    case AUDIT_RESULT.MISSING_SUGGESTIONS:
      return 'Missing required evidence or test procedures'
    case AUDIT_RESULT.NOT_RUN:
    default:
      if (testName === CONTROL_TEST_NAMES.POLICY_MATCH) {
        return 'Not Examined'
      }
      return 'Not Tested'
  }
}

export const getControlCheckResultPillColor = (
  result: AUDIT_RESULT,
): string => {
  return CONTROL_CHECK_RESULT_PILL_COLOR[result]
}
